import { FC, useMemo } from 'react'
import useMediaQuery from 'hooks/useMediaQuery'
import { TCard } from 'lib/region'
import Typography from 'components/Typography'
import Button from 'components/Button'
import Carousel from 'components/Carousel'
import styles from './DataCarousel.module.scss'

type TProps = {
  items: Array<TCard>
  staticNavigation?: boolean
  slidesPerPage?: {
    mobile?: number
    tablet?: number
    desktop?: number
  }
}

const defaultSlidesPerPage = { mobile: 1.3, tablet: 2.3, desktop: 4 }

const DataCarousel: FC<TProps> = ({
  items,
  staticNavigation,
  slidesPerPage = defaultSlidesPerPage,
}) => {
  const isDeskResolution = useMediaQuery('(min-width: 1024px)')
  const isTabletResolution = useMediaQuery('(min-width: 768px)')
  const carouselSlidesPerPage = useMemo(() => {
    if (isDeskResolution)
      return slidesPerPage.desktop || defaultSlidesPerPage.desktop
    if (isTabletResolution)
      return slidesPerPage.tablet || defaultSlidesPerPage.tablet
    return slidesPerPage.mobile || defaultSlidesPerPage.mobile
  }, [slidesPerPage, isDeskResolution, isTabletResolution])

  return (
    <Carousel
      slidesPerPage={carouselSlidesPerPage}
      slidesGap={32}
      pagination={{ hide: true }}
      navigation={{ verticalPosition: 'bottom' }}
      trackMouse={false}
      staticNavigation={isDeskResolution && staticNavigation}
      items={items.map(({ title, value, button }) => (
        <div className={styles.ecRegionDataCardContainer} key={title}>
          <div className={styles.ecRegionDataCardTop}>
            <Typography as="h3" variant="ParagraphBig" bold>
              {title}
            </Typography>
            <Typography variant="Title" bold>
              {value}
            </Typography>
          </div>
          {button && (
            <Button
              element={button.href ? 'a' : 'button'}
              href={button.href}
              onClick={() => {
                if (button.onClick) button.onClick()
              }}
            >
              {button.label}
            </Button>
          )}
        </div>
      ))}
    />
  )
}

export default DataCarousel
